export default class LinkedListNode {
  constructor(data) {
      this.data = data;
      this.next = null;
  }
}